export class RequestAccessModel {
    public requestorEmail: string = '';
    public requestorFirstname: string = '';
    public requestorLastname: string = '';
    public tenant: string = '';
    public asset: string = '';
    public reason: string = '';
}